require('./bootstrap');
import Agent from "@egjs/agent";

document.addEventListener("DOMContentLoaded", function() {
    feather.replace();
    $( '#flash-overlay-modal' ).modal();
    $( 'div.alert' ).not( '.alert-important' ).delay( 3000 ).fadeOut( 100 );
})

function setCookie(cookie_name, value, days) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + days);
    // 설정 일수만큼 현재시간에 만료값으로 지정

    var cookie_value = escape(value) + ((days == null) ? '' : ';    expires=' + exdate.toUTCString());
    document.cookie = cookie_name + '=' + cookie_value;
}

function getCookie(cookie_name) {
    var x, y;
    var val = document.cookie.split(';');

    for (var i = 0; i < val.length; i++) {
        x = val[i].substr(0, val[i].indexOf('='));
        y = val[i].substr(val[i].indexOf('=') + 1);
        x = x.replace(/^\s+|\s+$/g, ''); // 앞과 뒤의 공백 제거하기
        if (x == cookie_name) {
            return unescape(y); // unescape로 디코딩 후 값 리턴
        }
    }
}

const agent = Agent();
const browserAlert = document.getElementById('browser-alert');
$(browserAlert).on('close.bs.alert', () => {
    setCookie('browserAlert', 'hidden', 1);
});

if (agent.browser.name === 'ie' && agent.browser.version.match(/11\.*/)) {
    const checkBrowser = getCookie('browserAlert');
    if (checkBrowser === undefined || checkBrowser === 'show') {
        browserAlert.querySelector('.name').innerText = agent.browser.name;
        browserAlert.querySelector('.version').innerText = agent.browser.version;
        browserAlert.querySelector('.os').innerText = `${agent.os.name} / ${agent.os.version}`;
        browserAlert.style.display = '';
        $(browserAlert).alert();
    }
} else {
    if ( browserAlert ) {
        browserAlert.style.display = 'none';
    }
}

(($) => {
    $('#flash-overlay-modal').modal();
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
    $('div.alert').not('.alert-important').delay(3000).fadeOut(350);
    $('aside a[href="' + currentUrl + '"].nav-link').addClass('active');
    $('aside a[href="' + currentFullUrl + '"].nav-link').addClass('active');
})(jQuery);


const commonSearchToggler = document.getElementById('common-search-section-toggler');
const searchSection = document.getElementById('common-search-section');
if (commonSearchToggler) {
    commonSearchToggler.addEventListener('click', e => {
        if (searchSection) {
            $(searchSection).collapse('toggle');
        }
    });
}

if (window.screen.width > 576) {
    if ( searchSection ) {
        searchSection.classList.add('show');
    }
}

window.getProvinces = annualConfId => {
    return axios.get(`/api/${annualConfId}/provinces`);
};

window.getChurches = (provinceId = null) => {
    if (provinceId) {
        return axios.get(`/api/${provinceId}/churches`);
    }
    return false;
};

window.makeOption = (arr, title = '선택...') => {
    const code = document.createDocumentFragment();
    const defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = title;
    code.appendChild(defaultOpt);
    arr.map((el) => {
        const opt = document.createElement('option');
        opt.value = el.id;
        opt.textContent = el.name;
        code.appendChild(opt);
    });

    return code;
};

window.deletePastor = function (id) {
    axios.delete(`/address/pastors/destroy/${id}`)
        .then(r => {
            const tg = document.querySelector(`tr#pastor-${id}`);
            if (tg) {
                tg.remove();
            }
        })
        .catch((err) => {
            if (err.response) {
                if (err.response.status === 404) {
                    alert('해당 레코드가 존재하지 않습니다.');
                    $('tr#pastor-' + id).remove();
                } else if (err.response.status === 500) {
                    alert(err.response.data.message);
                } else {
                    alert(err.response.data.message);
                }
            } else {
                alert('오류 : ' + err.message);
            }
        });
};


window.searchPastor = keyword => axios.get(`/api/search/pastor?keyword=${keyword}`);

window.checkedItemId = () => {
    let checkedItems = document.querySelectorAll('input[name="id[]"]:checked');
    if (checkedItems.length > 1) {
        alert('하나만 선택하세요.');
        checkedItems.map(el => el.checked = false);
        return false;
    }
    if (checkedItems.length === 0) {
        alert('선택된 항목이 없습니다.');
        return false;
    }

    return checkedItems[0].value;
};


window.makePastorTable = (arr) => {
    if (arr) {
        const code = [];

        arr.map(el => {
            code.push('<tr>');
            code.push(`<td class="text-center">${el.name}</td>`);
            code.push(`<td class="text-center">${el.class}</td>`);

            if ( isAdmin ) {
                code.push(`<td class="text-center">${el.phone ? el.phone : ''}</td>`);
                code.push(`<td class="text-center">${el.birth ? el.birth : ''}</td>`);
                code.push(`<td class="text-center">${el.min_year ? el.min_year : ''}</td>`);
                code.push(`<td class="text-center">${el.min_year2 ? el.min_year2 : ''}</td>`);
                code.push(`<td class="text-center">${el.univ ? el.univ : ''}</td>`);
                code.push(`<td class="text-center">${el.univ2 ? el.univ2 : ''}</td>`);
            }
            code.push(`<td class="text-center">${el.etc ? el.etc : '' }</td>`);

            if ( isAdmin ) {
                code.push(`<td class="text-center">${el.admin_etc ? el.admin_etc : ''}</td>`);
            }
            code.push('</tr>');
        });

        return code.join('');
    }
};
